/* c_similar-products — 「似たような商品」セクション (issue #134) */
(function () {
  'use strict';

  // メタフィールドに全角スペース・末尾スペースの混入があるため、比較前に揃えます。
  function normalize(value) {
    if (!value) return '';
    var text = String(value).replace(/　/g, ' ').replace(/\s+/g, ' ').trim();
    if (text.normalize) text = text.normalize('NFKC');
    return text.toLowerCase();
  }

  function ladder(root) {
    return ['1', '2', '3']
      .map(function (level) {
        return root.getAttribute('data-url-' + level);
      })
      .filter(function (url) {
        return url;
      });
  }

  // Impulse のグリッドは .grid > .grid__item 前提なので包みは外します。
  // クイックショップ用モーダルも包みの中にあるため、子要素をまとめて移します。
  function itemsFrom(html) {
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var wrappers = doc.querySelectorAll('.c_similar-fragment__item');
    return Array.prototype.map
      .call(wrappers, function (wrapper) {
        var card = wrapper.querySelector('.grid__item');
        if (!card) return null;
        return {
          handle: card.getAttribute('data-product-handle') || wrapper.getAttribute('data-handle'),
          color: wrapper.getAttribute('data-color'),
          nodes: Array.prototype.slice.call(wrapper.children)
        };
      })
      .filter(function (item) {
        return item && item.handle;
      });
  }

  function collect(root) {
    var exclude = root.getAttribute('data-exclude') || '';
    var min = parseInt(root.getAttribute('data-min'), 10) || 3;
    var urls = ladder(root);
    var seen = Object.create(null);
    var picked = [];

    // 上の段から順に試し、min に届いたら止めます。
    function step(index) {
      if (index >= urls.length || picked.length >= min) {
        return Promise.resolve(picked);
      }
      return fetch(urls[index])
        .then(function (response) {
          if (!response.ok) throw new Error('status ' + response.status);
          return response.text();
        })
        .then(function (html) {
          itemsFrom(html).forEach(function (item) {
            if (item.handle === exclude || seen[item.handle]) return;
            seen[item.handle] = true;
            picked.push(item);
          });
        })
        .catch(function () {
          // 1 段が落ちても次の段を試します。
        })
        .then(function () {
          return step(index + 1);
        });
    }

    return step(0);
  }

  function render(root, items) {
    var grid = root.querySelector('[data-c-similar-grid]');
    if (!grid) return;

    var wanted = normalize(root.getAttribute('data-color'));
    var max = parseInt(root.getAttribute('data-max'), 10) || 5;

    // 同色を先に。各群の中では取得順を保ちます。
    var sameColor = [];
    var others = [];
    items.forEach(function (item) {
      if (wanted && normalize(item.color) === wanted) {
        sameColor.push(item);
      } else {
        others.push(item);
      }
    });

    var ordered = sameColor.concat(others).slice(0, max);
    if (!ordered.length) return;

    var fragment = document.createDocumentFragment();
    ordered.forEach(function (item) {
      item.nodes.forEach(function (node) {
        fragment.appendChild(document.importNode(node, true));
      });
    });
    grid.appendChild(fragment);
    root.hidden = false;

    // 表示に切り替えたあとに付けます。AOS は refreshHard 時の位置で判定するため、
    // この順序だとスマホで横からのスライドインが効きます。
    grid.setAttribute('data-aos', 'overflow__animation');

    // product-recommendations と同じ後処理。AOS のスライドイン、クイックショップ、
    // collapsible の再初期化をまとめて行います。
    if (window.theme && typeof theme.reinitProductGridItem === 'function') {
      theme.reinitProductGridItem(root);
    } else if (window.AOS) {
      AOS.refreshHard();
    }

    upgradeCta(root);
  }

  // ヘッダーは position: fixed で高さも表示幅により変わるため、
  // 実測してから位置を決めます（固定値だと見出しが隠れます）。
  function scrollToSection(root) {
    var header = document.querySelector('.site-header');
    var offset = header ? header.getBoundingClientRect().height : 0;
    var top = root.getBoundingClientRect().top + window.pageYOffset - offset - 24;
    window.scrollTo({ top: Math.max(top, 0), behavior: 'smooth' });
  }

  // 売り切れページの CTA は、Liquid 側ではモデルコレクションを指しています。
  // セクションに商品が入った場合だけページ内アンカーへ差し替えます。
  function upgradeCta(root) {
    var cta = document.querySelector('[data-c-similar-cta]');
    if (!cta || !root.id) return;
    cta.setAttribute('href', '#' + root.id);
    cta.addEventListener('click', function (event) {
      event.preventDefault();
      scrollToSection(root);
    });
  }

  function init(root) {
    if (root.hasAttribute('data-c-similar-ready')) return;
    root.setAttribute('data-c-similar-ready', '');
    collect(root).then(function (items) {
      render(root, items);
    });
  }

  function boot() {
    document.querySelectorAll('[data-c-similar]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  // テーマエディタでの差し替えに対応します。
  document.addEventListener('shopify:section:load', function (event) {
    event.target.querySelectorAll('[data-c-similar]').forEach(init);
  });
})();
